import { env } from '../appConfig';

let loadGeneration = 0;

const bumpGeneration = () => ++loadGeneration;

const isCurrentGeneration = (generation) => generation === loadGeneration;

const isBrandExcluded = () =>
	window.isVirtuoso?.() || window.isGoldenticket?.();

/** @deprecated Legacy script-tag marker; kept for cleanup of old sessions */
const LEGACY_SCRIPT_HEADER_ID = 'traveBrandHeader';

export const hasInjectedSharedHeader = () =>
	Boolean(
		document.querySelector(`#${LEGACY_SCRIPT_HEADER_ID}`) ||
		document.querySelector('.travelbrands-header') ||
		document.querySelector('#hdrWrap')
	);

export const hasInjectedSharedFooter = () =>
	Boolean(
		document.querySelector('#footerWrapper') ||
		document.querySelector('.travelbrands-footer')
	);

const removeInjectedHeaderNodes = (body) => {
	if (!body) return;
	const head = document.querySelector('head');
	const scriptHeader = document.querySelector(`#${LEGACY_SCRIPT_HEADER_ID}`);
	if (scriptHeader && head) {
		head.removeChild(scriptHeader);
	}
	body.querySelectorAll('.travelbrands-header, #hdrWrap, #topImg').forEach((el) => el.remove());
};

const removeInjectedFooterNodes = (body) => {
	if (!body) return;
	body.querySelectorAll('#footerWrapper, .travelbrands-footer').forEach((el) => el.remove());
};

export const removeSharedChrome = () => {
	const body = document.querySelector('body');
	removeInjectedHeaderNodes(body);
	removeInjectedFooterNodes(body);
};

export const hideOrphanBrTags = () => {
	const root = document.querySelector('#root');
	if (!root) return;

	let node = root.previousSibling;
	while (node) {
		if (node.nodeName === 'BR') {
			node.style.display = 'none';
		}
		node = node.previousSibling;
	}
};

const removeInternalGearIcon = () => {
	let attempts = 0;
	const intervalId = setInterval(() => {
		const parent = document.querySelector('#subNav');
		const gearIcon = document.querySelector('#gear');
		if (parent && gearIcon) {
			parent.removeChild(gearIcon);
			clearInterval(intervalId);
		} else if (attempts >= 9) {
			clearInterval(intervalId);
		}
		attempts += 1;
	}, 100);
};

const fetchFragment = async (url) => {
	const response = await fetch(url);
	if (!response.ok) {
		throw new Error(`Failed to load shared chrome fragment: ${url}`);
	}
	return response.text();
};

const resolveChromeUrls = ({ mode, language, token }) => {
	if (window.isHISUK?.()) {
		return {
			headerUrl: `${env.REACT_APP_HISUK_HEADER_URL}?lang=${language}`,
			footerUrl: `${env.REACT_APP_HISUK_FOOTER_URL}?lang=${language}`,
		};
	}

	if (mode === 'external') {
		return {
			headerUrl: `${env.REACT_APP_NEW_HEADER_URL}?token=${token}&lang=${language}`,
			footerUrl: `${env.REACT_APP_NEW_FOOTER_URL}?lang=${language}&token=${token}`,
		};
	}

	return {
		headerUrl:
			language === 'fr' ? env.REACT_APP_HEADER_URL_FRENCH : env.REACT_APP_HEADER_URL,
		footerUrl:
			language === 'fr' ? env.REACT_APP_FOOTER_URL_FRENCH : env.REACT_APP_FOOTER_URL,
	};
};

const loadSharedChrome = async ({ mode, language, token, generation, isInternalUser }) => {
	const headerLoader = document.getElementById('headerLoader');
	const footerLoader = document.getElementById('footerLoader');
	const body = document.body;
	const { headerUrl, footerUrl } = resolveChromeUrls({ mode, language, token });

	try {
		const [headerHtml, footerHtml] = await Promise.all([
			fetchFragment(headerUrl),
			fetchFragment(footerUrl),
		]);

		if (!isCurrentGeneration(generation)) return;

		body.insertAdjacentHTML('afterbegin', headerHtml);
		body.insertAdjacentHTML('beforeend', footerHtml);
		headerLoader?.classList?.remove('show');
		footerLoader?.classList?.remove('show');

		if (isInternalUser) {
			removeInternalGearIcon();
		}
	} catch {
		if (!isCurrentGeneration(generation)) return;
		headerLoader?.classList?.remove('show');
		footerLoader?.classList?.remove('show');
	}
};

/**
 * Sync Travel Brands shared HTML header/footer with the current route and user.
 * @param {{ pathname: string, language: string, mode: 'none'|'internal'|'external', token?: string, forceRefresh?: boolean, isInternalUser?: boolean }} options
 */
export const syncSharedChrome = ({
	pathname,
	language,
	mode,
	token = '',
	forceRefresh = false,
	isInternalUser = false,
}) => {
	if (isBrandExcluded()) return;

	if (pathname === '/login' || mode === 'none') {
		if (hasInjectedSharedHeader() || hasInjectedSharedFooter()) {
			removeSharedChrome();
		}
		return;
	}

	if (document.querySelector('.main-header')) {
		return;
	}

	if (!forceRefresh && hasInjectedSharedHeader() && hasInjectedSharedFooter()) {
		return;
	}

	if (forceRefresh || hasInjectedSharedHeader() || hasInjectedSharedFooter()) {
		removeSharedChrome();
	}

	if (mode === 'external' && !token) {
		return;
	}

	const generation = bumpGeneration();
	loadSharedChrome({ mode, language, token, generation, isInternalUser });
	hideOrphanBrTags();
};
